import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { configService } from "./Config/ConfigService";

class AppInsights {

    private appInsights: ApplicationInsights | undefined

    async load() {

        var config = await configService.getConfiguration()

        if (config && config.ApplicationInsights.ConnectionString) {
            this.appInsights = new ApplicationInsights({
                config: {
                    connectionString: config.ApplicationInsights.ConnectionString
                }
            });
            this.appInsights.loadAppInsights();
            this.appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
        }
    }
    async logError(ex: Error){
            this.appInsights?.trackException({exception: ex});
    }
}
export const appInsights = new AppInsights();